export default "__VITE_ASSET__DARe8DPy__"